import { useState } from "react";

class ActiveOperations {
    static current: number = 0;
}

export const useBusy = () => {
    const [isBusy, setIsBusy] = useState<boolean>(false);

    const performTask = async <T,>(task: () => T) => {
        ActiveOperations.current++;
        setIsBusy(!!ActiveOperations.current);

        try {
            const result = await task();
            return result;
        }
        finally {
            ActiveOperations.current--;
            setIsBusy(!!ActiveOperations.current);
        }
    };

    return {
        isBusy,
        busyWhile: <T,>(task: () => T): Promise<T> => performTask(task)
    };
};